import { cloneDeep } from 'lodash-es';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AvailableProduct } from '../../../shopping-cart-back/actions/standalone';

import { parseProductConfigEntry } from '../../helpers';
import { CustomProductAttributeConfig } from '../../../types';
import { TypedFormBuilder } from '../../../../form/TypedFormBuilder';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
  selector: 'lib-view-product-in-package',
  templateUrl: './view-product-in-package.component.html',
  styleUrls: ['./view-product-in-package.component.scss'],
  providers: [translationProvider('productFront')],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ViewProductInPackageComponent implements OnInit {
  @Input() productInPackage: {
    qty?: number;
    productId?: string;
    productInPackageId?: string;
    config?: string;
    icon?: string;
    customName?: Array<{ language: string; text: string }>;
  };
  @Input() productInShop: AvailableProduct;
  @Input() packageId: string;
  @Output() hideDialog = new EventEmitter();
  filtered: Array<CustomProductAttributeConfig> = [];
  copyConfiguration: Array<CustomProductAttributeConfig> = [];
  model = this.fb.group({});
  isPhonePortrait$ = this.screenObserver
    .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
    .pipe(map(({ matches }) => matches));
  images = {
    imagesRequired: false,
    requiredImages: { max: 0, min: 0 },
  };

  constructor(
    private screenObserver: BreakpointObserver,
    private fb: TypedFormBuilder,
  ) {}

  ngOnInit() {
    this.images.imagesRequired = this.productInShop.imagesRequired;
    this.images.requiredImages = this.productInShop.requiredImages;
    const filtered = [];
    let newConfig = {};
    this.productInShop.config.forEach((x) => {
      const config = cloneDeep(x);
      const attribute: {} = Object.entries(
        JSON.parse(this.productInPackage.config),
      ).find((value) => value[0] === config.customId);
      if (attribute) {
        switch (config.type) {
          case 'boolean':
            newConfig = {
              ...newConfig,
              [config.customId]: attribute[1].value,
            };
            break;
          case 'list':
          case 'decoration':
          case 'size':
            newConfig = {
              ...newConfig,
              [config.customId]: attribute[1].value[0],
            };
            const option = config?.options.find(
              ({ configId }) => configId === attribute[1].value[0],
            );
            if (option && option.hasRequiredImagesModifier) {
              this.images.imagesRequired = option.hasRequiredImagesModifier;
              this.images.requiredImages = option.requiredImagesModifier;
            }
            break;
          case 'counter':
            newConfig = {
              ...newConfig,
              [config.customId]: attribute[1].min,
            };
            config.counterConfig.min = attribute[1].min;
            config.counterConfig.max = attribute[1].max;
            break;
        }
        this.copyConfiguration.push(config);
      } else {
        if (config.type === 'text' || config.type === 'file') {
          this.copyConfiguration.push(config);
        }
      }
    });
    parseProductConfigEntry(
      this.copyConfiguration,
      this.model,
      newConfig,
      filtered,
      true,
      true,
      true,
      true,
    );
    if (JSON.stringify(this.filtered) !== JSON.stringify(filtered)) {
      this.filtered = filtered;
      this.model.patchValue(newConfig);
    }
  }
}
